<template>
  <div class="app-container crm-detail">
    <el-card class="crm-detail-base" shadow="never">
      <el-row>
        <el-col :span="16">
          <span class="base-name">{{detail.invoiceTitle}}</span>
        </el-col>
      </el-row>
      <div>
        <div class="base-item">
          <div class="title label">客户名称</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail()">{{detail.customerName}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">合同编号</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContractDetail()">{{detail.contractNum}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">开票金额</div>
          <div class="value">{{amountFormat(detail.invoiceAmount)}}</div>
        </div>
        <div class="base-item">
          <div class="title label">开票时间</div>
          <div class="value">{{detail.invoiceDate}}</div>
        </div>
      </div>
    </el-card>
    <el-row :gutter="16">
      <el-col :span="16">
        <el-card class="crm-detail-main" v-if="detail.id" shadow="never">
          <el-tabs v-model="activeName" @tab-click="handleTabClick" :stretch="true">
            <el-tab-pane label="跟进计划" name="followPlan">
              <el-tabs v-model="followPlanActiveName" type="card" :stretch="true">
                <el-tab-pane label="跟进记录" name="follow">
                  <FollowAdd :targetId="detail.id" targetType="contractInvoice" @success="handleAfterFollowAdd"></FollowAdd>
                  <div style="height: 473px">
                    <FollowList :targetId="detail.id" targetType="contractInvoice" ref="followListRef"></FollowList>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="工作计划" name="workPlan">
                  <WorkPlan ref="workPlanRef" :targetId="detail.id" targetType="contractInvoice" :managerId="null" @success="handleAfterWorkPlanAdd"></WorkPlan>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="详细资料" name="detail">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="text" @click="handleEdit" v-if="!editModel" :disabled="!detail.id">编辑资料</el-button>
                  <el-button type="primary" @click="handleEditSave" v-if="editModel">保存</el-button>
                  <el-button  @click="editModel=false" v-if="editModel">取消</el-button>
                </el-col>
              </el-row>
              <el-form :model="updateData" :rules="updateRules" ref="updateForm" label-width="100px" :hide-required-asterisk="!editModel">
                <el-card shadow="never" class="el-card-simple">
                  <div slot="header">
                    <span>开票信息</span>
                  </div>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="合同编号:">
                        <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContractDetail()">{{detail.contractNum}}</el-link>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="客户名称:">
                        <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail()">{{detail.customerName}}</el-link>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="发票号码:" prop="invoiceNum">
                        <el-input v-if="editModel" v-model="updateData.invoiceNum" :maxlength="64" placeholder="请输入发票号码" clearable/>
                        <span v-else class="value">{{detail.invoiceNum}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="开票抬头:" prop="invoiceTitle">
                        <el-input v-if="editModel" v-model="updateData.invoiceTitle" :maxlength="64" placeholder="请输入开票抬头" clearable/>
                        <span v-else class="value">{{detail.invoiceTitle}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="抬头类型:" prop="titleType">
                        <el-select v-if="editModel" v-model="updateData.titleType" placeholder="请选择抬头类型" @change="titleTypeChange" clearable style="width:100%">
                          <el-option v-for="dict in titleTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                        <span v-else class="value">{{detail.titleTypeDesc}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="开票类型:" prop="invoiceCreateType">
                        <el-select v-if="editModel" v-model="updateData.invoiceCreateType" placeholder="请选择开票类型" @change="invoiceCreateTypeChange" clearable style="width:100%">
                          <el-option v-for="dict in invoiceCreateTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                        <span v-else class="value">{{detail.invoiceCreateTypeDesc}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="发票类型:" prop="invoiceType">
                        <el-select v-if="editModel" v-model="updateData.invoiceType" placeholder="请选择发票类型" clearable style="width:100%">
                          <el-option v-for="dict in invoiceTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                        <span v-else class="value">{{detail.invoiceTypeDesc}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="开票税率:" prop="invoiceTaxRate">
                        <el-select v-if="editModel" v-model="updateData.invoiceTaxRate" placeholder="请选择开票税率" clearable style="width:100%">
                          <el-option v-for="dict in invoiceTaxRateOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                        <span v-else class="value">{{detail.invoiceTaxRate}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="开票金额:" prop="invoiceAmount">
                        <el-input-number v-if="editModel" v-model="updateData.invoiceAmount" placeholder="请输入开票金额" :min="0" :max="999999999" :precision="2" :controls="false" clearable class="crm-input-number-wrap"/>
                        <span v-if="editModel" class="el-input__suffix">元</span>
                        <span v-if="!editModel" class="value">{{amountFormat(detail.invoiceAmount)}}元</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="开票时间:" prop="invoiceDate">
                        <el-date-picker v-if="editModel" v-model="updateData.invoiceDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
                        <span v-else class="value">{{detail.invoiceDate}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12" v-if="!editModel && detail.titleType === 'cooperation'">
                      <el-form-item label="公司税号:">
                        <span class="value">{{detail.companyTaxNum}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12" v-if="editModel && updateData.titleType === 'cooperation'">
                      <el-form-item label="公司税号:" prop="companyTaxNum">
                        <el-input v-model="updateData.companyTaxNum" :maxlength="64" placeholder="请输入公司税号" clearable/>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                      <el-form-item label="创建人:">
                        <span class="value">{{detail.createUserName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                      <el-form-item label="创建时间:">
                        <span class="value">{{detail.createTime}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="24" :lg="24">
                      <el-form-item label="发票文件:" prop="fileObjs">
                        <FileUpload v-if="editModel" v-model="updateData.fileObjs" :limit="5" :readOnly="false" @on-change="handleFileChange"></FileUpload>
                        <FileUpload v-else v-model="detail.fileUrls" :limit="5" :readOnly="true"></FileUpload>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="24" :lg="24">
                      <el-form-item label="开票备注:" prop="remark">
                        <el-input v-if="editModel" type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="200" show-word-limit v-model="updateData.remark" placeholder="请输入开票备注" clearable/>
                        <span v-else class="value">{{detail.remark}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <el-card shadow="never" class="el-card-simple">
                  <div slot="header">
                    <span>开票邮寄信息</span>
                  </div>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="收票人姓名:" prop="invoiceReceiver.receiverName">
                        <el-input v-if="editModel" v-model="updateData.invoiceReceiver.receiverName" :maxlength="32" placeholder="请输入收票人姓名" clearable/>
                        <span v-else class="value">{{detail.invoiceReceiver.receiverName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="收票人电话:" prop="invoiceReceiver.receiverMobile">
                        <el-input v-if="editModel" v-model="updateData.invoiceReceiver.receiverMobile" placeholder="请输入手机号" clearable/>
                        <span v-else class="value">{{detail.invoiceReceiver.receiverMobile}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12" v-if="!editModel && detail.invoiceCreateType === 'paper_invoice'">
                      <el-form-item label="收票人地址:">
                        <span class="value">
                          {{detail.invoiceReceiver.receiverProvinceName}}{{detail.invoiceReceiver.receiverCityName}}{{detail.invoiceReceiver.receiverDistrictName}}{{detail.invoiceReceiver.receiverDetailAddress}}
                        </span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12"v-if="editModel && updateData.invoiceCreateType === 'paper_invoice'" key="invoiceReceiver.area">
                      <el-form-item label="收票人地址:" prop="invoiceReceiver.area">
                        <el-cascader v-model="updateData.invoiceReceiver.area" :options="areaOptions" filterable clearable style="width:100%"></el-cascader>
                      </el-form-item>
                      <el-form-item label="" prop="invoiceReceiver.receiverDetailAddress">
                        <el-input type="textarea"
                                  :autosize="{ minRows: 3, maxRows: 5}"
                                  placeholder="请输入详细地址"
                                  :maxlength="100"
                                  show-word-limit
                                  v-model="updateData.invoiceReceiver.receiverDetailAddress">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12" v-if="!editModel && detail.invoiceCreateType === 'paper_invoice'">
                      <el-form-item label="收票人邮编:">
                        <span class="value">{{detail.invoiceReceiver.receiverPostCode}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12" v-if="editModel && updateData.invoiceCreateType === 'paper_invoice'" key="invoiceReceiver.receiverPostCode">
                      <el-form-item label="收票人邮编:" prop="invoiceReceiver.receiverPostCode">
                        <el-input v-model="updateData.invoiceReceiver.receiverPostCode" :maxlength="12" placeholder="请输入收票人邮编" clearable/>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12" v-if="!editModel && detail.invoiceCreateType === 'electronic_invoice'">
                      <el-form-item label="收票人邮箱:">
                        <span class="value">{{detail.invoiceReceiver.receiverEmail}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12" v-if="editModel && updateData.invoiceCreateType === 'electronic_invoice'" key="invoiceReceiver.receiverEmail">
                      <el-form-item label="收票人邮箱:" prop="invoiceReceiver.receiverEmail">
                        <el-input v-model="updateData.invoiceReceiver.receiverEmail" :maxlength="64" placeholder="请输入收票人邮箱" clearable/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="crm-detail-follow" v-if="detail.id" shadow="never">
          <el-divider content-position="left"><span class="label">操作日志</span></el-divider>
          <div style="height: 534px">
            <OperateLogList ref="operateLogListRef" :targetId="detail.id" targetType="contractInvoice"></OperateLogList>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import FollowList from "@/views/crm/follow/followList";
import FollowAdd from "@/views/crm/follow/followAdd";
import WorkPlan from "@/views/crm/workPlan/workPlan";
import OperateLogList from "@/views/crm/components/operateLogList";
import FileUpload from "@/views/crm/components/fileUpload";
import {amountFormat, transferCascaderOptionsForProvince} from '@/utils/index'
import {queryContractInvoiceDetail, updateContractInvoice} from "@/api/crm/invoice";
import {emailValid, validPhone} from "@/utils/validator";
import {listAllLevelArea} from "@/api/crm/area";

export default {
  name: "InvoiceDetail",
  data() {
    return {
      // 遮罩层
      amountFormat,
      loading: true,
      detail: {
        invoiceReceiver: {}
      },
      activeName: "followPlan",
      followPlanActiveName: 'follow',
      editModel: false,
      titleTypeOptions: [],
      invoiceCreateTypeOptions: [],
      invoiceTypeOptions: [],
      invoiceTaxRateOptions: [],
      areaOptions: [],
      updateRules: {
        invoiceTitle: [
          {required: true, message: '请输入开票抬头', trigger: 'change'}
        ],
        titleType: [
          {required: true, message: '请选择抬头类型', trigger: 'change'}
        ],
        invoiceCreateType: [
          {required: true, message: '请选择开票类型', trigger: 'change'}
        ],
        invoiceType: [
          {required: true, message: '请选择发票类型', trigger: 'change'}
        ],
        invoiceAmount: [
          {required: true, type:'number', message: '请输入开票金额', trigger: 'blur'}
        ],
        invoiceDate: [
          {required: true, message: '请选择开票时间', trigger: 'change'}
        ],
        'invoiceReceiver.receiverMobile': [
          { validator: validPhone, trigger: "change" }
        ],
        'invoiceReceiver.receiverEmail': [
          { validator: emailValid, trigger: "change" }
        ]
      },
      updateData: {
        id: null,
        invoiceTitle: null,
        titleType: null,
        invoiceCreateType: null,
        invoiceType: null,
        companyTaxNum: null,
        invoiceTaxRate: null,
        invoiceAmount: undefined,
        invoiceDate: null,
        invoiceNum: null,
        remark: null,
        fileObjs: [],
        invoiceReceiver: {
          receiverName: null,
          receiverMobile: null,
          area: [],
          receiverDetailAddress: null,
          receiverPostCode: null,
          receiverEmail: null,
        }
      }
    };
  },
  components: {
    FollowList,
    FollowAdd,
    WorkPlan,
    OperateLogList,
    FileUpload
  },
  created() {
    if (this.$route.params.id) {
      this.queryDetail().then(() => {
        if (this.detail.id && String(this.$route.query.edit) === '1') {
          this.activeName = 'detail'
          this.handleEdit()
        }
      })
      this.getDicts("invoice_title_type").then(response => {
        this.titleTypeOptions = response.data;
      });
      this.getDicts("invoice_create_type").then(response => {
        this.invoiceCreateTypeOptions = response.data;
      });
      this.getDicts("invoice_type").then(response => {
        this.invoiceTypeOptions = response.data;
      });
      this.getDicts("invoice_tax_rate").then(response => {
        this.invoiceTaxRateOptions = response.data;
      });
      listAllLevelArea({ level: 3 }).then(response => {
        this.areaOptions = transferCascaderOptionsForProvince(response.data);
      });
    } else {
      this.msgError("无效的合同");
    }
  },
  watch: {
    editModel (val) {
      if (!val) {
        this.updateData = {
          id: null,
            invoiceTitle: null,
            titleType: null,
            invoiceCreateType: null,
            invoiceType: null,
            companyTaxNum: null,
            invoiceTaxRate: null,
            invoiceAmount: undefined,
            invoiceDate: null,
            invoiceNum: null,
            remark: null,
            fileObjs: [],
            invoiceReceiver: {
            receiverName: null,
              receiverMobile: null,
              area: [],
              receiverDetailAddress: null,
              receiverPostCode: null,
              receiverEmail: null,
          }
        }
        this.resetForm("updateForm");
      }
    }
  },
  methods: {
    handleTabClick (tab) {
    },
    refreshDetailAndLog() {
      this.queryDetail()
      this.refreshOperateLogList();
    },
    queryDetail () {
      return queryContractInvoiceDetail({id:this.$route.params.id}).then(response => {
        if (response.data) {
          this.detail = Object.assign({ invoiceReceiver: {} }, response.data)
          this.detail.invoiceReceiver = this.detail.invoiceReceiver || {}
        } else {
          this.msgError("查询不到此开票记录");
        }
      }).catch(error => {
        this.detail = { invoiceReceiver: {} }
      })
    },
    handleAfterFollowAdd () {
      this.$refs.followListRef.refresh()
      this.queryDetail()
    },
    refreshOperateLogList () {
      this.$refs.operateLogListRef.refresh()
    },
    handleEdit () {
      const invoiceReceiver = this.detail.invoiceReceiver || {};
      this.updateData.id = this.detail.id;
      this.updateData.invoiceTitle = this.detail.invoiceTitle;
      this.updateData.titleType = this.detail.titleType;
      this.updateData.invoiceCreateType = this.detail.invoiceCreateType;
      this.updateData.invoiceType = this.detail.invoiceType;
      this.updateData.companyTaxNum = this.detail.companyTaxNum;
      this.updateData.invoiceTaxRate = this.detail.invoiceTaxRate;
      this.updateData.invoiceAmount = this.detail.invoiceAmount;
      this.updateData.invoiceDate = this.detail.invoiceDate;
      this.updateData.invoiceNum = this.detail.invoiceNum;
      this.updateData.remark = this.detail.remark;
      this.updateData.fileObjs = this.detail.fileUrls || [];
      this.updateData.invoiceReceiver.receiverName = invoiceReceiver.receiverName;
      this.updateData.invoiceReceiver.receiverMobile = invoiceReceiver.receiverMobile;
      this.updateData.invoiceReceiver.receiverDetailAddress = invoiceReceiver.receiverDetailAddress;
      this.updateData.invoiceReceiver.receiverPostCode = invoiceReceiver.receiverPostCode;
      this.updateData.invoiceReceiver.receiverEmail = invoiceReceiver.receiverEmail;
      let area = []
      if (invoiceReceiver.receiverProvince) {
        area.push(+invoiceReceiver.receiverProvince)
      }
      if (invoiceReceiver.receiverCity) {
        area.push(+invoiceReceiver.receiverCity)
      }
      if (invoiceReceiver.receiverDistrict) {
        area.push(+invoiceReceiver.receiverDistrict)
      }
      this.updateData.invoiceReceiver.area = area
      this.editModel = true
    },
    titleTypeChange (titleType) {
      this.updateData.companyTaxNum = null;
    },
    invoiceCreateTypeChange (invoiceCreateType) {
      this.updateData.invoiceReceiver.receiverEmail = null;
      this.updateData.invoiceReceiver.receiverPostCode = null;
      this.updateData.invoiceReceiver.receiverDetailAddress = null;
      this.updateData.invoiceReceiver.area = [];
    },
    handleFileChange (fileObjs) {
      this.updateData.fileObjs = fileObjs;
    },
    handleEditSave () {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          let params = JSON.parse(JSON.stringify(this.updateData));
          if (params.fileObjs && params.fileObjs.length > 0) {
            params.fileObjs = params.fileObjs.map(item => {
              return { id: item.id };
            })
          }
          params.invoiceReceiver.receiverProvince = params.invoiceReceiver.area && params.invoiceReceiver.area.length > 0 ? params.invoiceReceiver.area[0] : null;
          params.invoiceReceiver.receiverCity = params.invoiceReceiver.area && params.invoiceReceiver.area.length > 1 ? params.invoiceReceiver.area[1] : null;
          params.invoiceReceiver.receiverDistrict = params.invoiceReceiver.area && params.invoiceReceiver.area.length > 2 ? params.invoiceReceiver.area[2] : null;

          updateContractInvoice(params).then(response => {
            this.refreshDetailAndLog();
            this.editModel = false
            loading.close();
            this.msgSuccess("更新成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    /** 详细按钮操作 */
    toContractDetail() {
      this.$router.push("/crm/contract/detail/" + this.detail.contractId);
    },
    /** 详细按钮操作 */
    toCustomerDetail() {
      this.$router.push("/crm/customer/detail/" + this.detail.customerId);
    },
    handleAfterWorkPlanAdd () {
      this.refreshOperateLogList();
      this.$refs["followListRef"].refresh()
    }
  }
};
</script>
